import { EAuthenticateError, EAuthenticateStatus } from '../../../../types/authentication';
import { isValidPhone } from '../../../../utils/validation';
import { ERequestStatus } from '../../../../types/requestStatus';
export function authenticateStatusSelector(state) {
  return state.authentication.authenticate.status;
}
export function twoFactorStatusSelector(state) {
  return state.authentication.twoFactor.phoneState.status;
}
export function hasCodeErrorSelector(state) {
  var _state$authentication = state.authentication.authenticate,
      status = _state$authentication.status,
      errorType = _state$authentication.errorType;
  return status === EAuthenticateStatus.Failed && errorType !== EAuthenticateError.TwoFactorRequired;
}
export function codeErrorSelector(state) {
  if (!hasCodeErrorSelector(state)) {
    return undefined;
  }

  return state.authentication.authenticate.error;
}
export function loginSelector(state) {
  return state.login;
}
export function phoneSelector(state) {
  return state.authentication.twoFactor.phoneState.phone;
}
export function phoneErrorSelector(state) {
  return state.authentication.twoFactor.phoneState.error;
}
export function isSubmitDisabledSelector(state) {
  var twoFactorStatus = twoFactorStatusSelector(state);
  var authenticateStatus = authenticateStatusSelector(state);
  return [EAuthenticateStatus.Loading, EAuthenticateStatus.Succeed].includes(authenticateStatus) || twoFactorStatus === ERequestStatus.Loading;
}
export function isPhoneInvalidSelector(state) {
  var phone = phoneSelector(state);
  return !isValidPhone(phone);
}
export function isAutosubmitEnabledSelector(state) {
  return state.authentication.twoFactor.phoneState.isAutosubmitEnabled;
}